
import { Document } from "./document";
import { NotificationMap } from "./notificatonmap";
import { SkillDocWrapper } from "../skills/skilldocwrapper";
import { UserAttrSkillWrapper } from '../skills/userattrskillwrapper';

export class Location {
    public locationAddress: string = "";
    // public locationLatitude: String = "";
    // public locationLongitude: String = "";
    // public long_name: String = "";
    
    public latitude: string = "";
    public longitude: string = "";
    public city: string = "";
    public state: string = "";
    public country: string = "";
    
}